import React, {Component} from 'react';
import {connect} from 'react-redux';
import {FormattedMessage} from "react-intl";
import PropTypes from 'prop-types';

import {
  setActiveNavigationFilter,
  setActiveNavigationFilterStepIndex,
  setNavigationViewType
} from "../../../../actions/navigationFunctions";
import {CABINET_WIZARD_BUTTONS, COUNTERTOP_WIZARD_BUTTONS} from "../../../kvComponent/core/constants";
import {setSelectedFilters} from "../../../../actions/actionFunctions";

class BodyPanelNavigationFiltersSteps extends Component {

  static propTypes = {
    activePart: PropTypes.object.isRequired,
  };

  setNavigationWizardStep = (buttonId, wizardButtonIndex) => {
    this.props.setActiveNavigationFilter(buttonId);
    this.props.setActiveNavigationFilterStepIndex(wizardButtonIndex);
    if (buttonId === COUNTERTOP_WIZARD_BUTTONS[2].buttonId) {
      this.props.setNavigationViewType(2)
    } else if (this.props.navigationViewType !== 3) {
      this.props.setNavigationViewType(3)
    }
    if (buttonId !== COUNTERTOP_WIZARD_BUTTONS[2].buttonId) {
      this.props.setSelectedFilters([]); // reset filters on stones & color step
    }
  };

  getAvailableSteps = () => {
    let wizardButtons = [];
    switch (this.props.activePart.partId) {
      case "top_cabinet":
      case "bottom_cabinet":
        wizardButtons = CABINET_WIZARD_BUTTONS.filter(wizardButton => wizardButton.buttonId !== "inlay_type");
        break;
      case "countertop":
      case "edge_profile":
      case "backsplash":
        wizardButtons = COUNTERTOP_WIZARD_BUTTONS;
        break;
      case "center_island_countertop":
      case "center_island_edge":
        wizardButtons = COUNTERTOP_WIZARD_BUTTONS.slice(0, 4);
        break;
      default:
        break;
    }
    return wizardButtons.map((wizardButton, wizardButtonIndex) => {
      wizardButton.onClick = () => this.setNavigationWizardStep(wizardButton.buttonId, wizardButtonIndex);
      return wizardButton
    })
  };

  render() {
    const countertopWizardPartIds = ["countertop", "center_island_countertop", "edge_profile", "center_island_edge", "backsplash"];
    let allowIcons = true;
    if (this.props.activePart.partId === "backsplash" && this.props.windowWidth < 1400) {
      allowIcons = false
    }

    return (
      <div className="panel-wizard">
        <ul className="panel-wizard-list">
          {this.getAvailableSteps().map((wizardButton, index) => {
            const disabled = false;
            const buttonIcon = countertopWizardPartIds.includes(this.props.activePart.partId)
            && wizardButton.buttonId === "all_products" ? "stones" : wizardButton.buttonId;
            return (
              <li className={"panel-wizard-list__button panel-wizard-list__button--" + buttonIcon
              + (index === this.props.activeNavigationFilterStepIndex ? " panel-wizard-list__button--active" : "")
              + (!allowIcons ? " panel-wizard-list__button--no-icon" : "")
              + (disabled ? " panel-wizard-list__button--disabled" : "")}
                  key={"wizardButton"+index} onClick={disabled ? () => {} : wizardButton.onClick}>
                {(buttonIcon !== CABINET_WIZARD_BUTTONS[0].buttonId) && allowIcons ? (
                  <span className="panel-wizard-list__button-icon"/>
                ) : null}
                <span className="panel-wizard-list__button-text">
                  <FormattedMessage id={wizardButton.pluralText || wizardButton.text}/>
                </span>
              </li>
            )
          })}
        </ul>
      </div>
    )
  }
}

const mapStateToProps = (store) => ({
  // fabricatorSettings: store.fabricatorState.settings,
  windowWidth: store.serverState.windowWidth,
  activeNavigationFilter: store.navigationState.activeNavigationFilter,
  activeNavigationFilterStepIndex: store.navigationState.activeNavigationFilterStepIndex,
  moduleContextMenuModule: store.navigationState.moduleContextMenuModule,
  moduleContextMenuModulePart: store.navigationState.moduleContextMenuModulePart,
  navigationViewType: store.navigationState.navigationViewType,
});

const mapDispatchToProps = {
  setActiveNavigationFilter,
  setActiveNavigationFilterStepIndex,
  setNavigationViewType,
  setSelectedFilters
};

export default connect(mapStateToProps, mapDispatchToProps)(BodyPanelNavigationFiltersSteps);
